import AccountHome, { type AccountHomeProps } from './AccountHome'

export {
  AccountHome,
  type AccountHomeProps
}

export default AccountHome
